/**
 * The key of the shell's page wrapper (`<div key={...} className="motion-page">`).
 *
 * A new key remounts the whole page: that is how a page plays its entry
 * motion and starts clean. Keyed by the full pathname, it ALSO remounted
 * pages that run their own sub-navigation every time they moved inside
 * themselves: Create with AI lost its whole conversation the moment the
 * preview stepped to the drafted module's first view
 * (`/admin/modules/ai/new` -> `/admin/modules/ai/new/contacts`, owner,
 * 2026-10-15: "it bugged and just refreshed the page"), and a custom module
 * started over on every view switch.
 *
 * Those pages are keyed by the page itself, so moving inside them keeps
 * their state; every other route keeps its full pathname, exactly as before.
 */
const OWN_ROUTERS: readonly RegExp[] = [
  /^\/admin\/modules\/ai\/new(?=\/|$)/,
  /^\/admin\/modules\/ai\/edit\/[^/]+(?=\/|$)/,
  /^\/m\/[^/]+(?=\/|$)/,
];

export function pageKey(pathname: string): string {
  for (const re of OWN_ROUTERS) {
    const m = pathname.match(re);
    if (m) return m[0];
  }
  return pathname;
}
